// extracted by mini-css-extract-plugin
export default {"button":"OAuthButton_button__R9+HD","icon":"OAuthButton_icon__wMH3e"};